enum DeviceGroupingTypes {
    Common = 1,
    Grouped,
    Distributed,
}

export default DeviceGroupingTypes;
